export default [
  {
    label: 'Service Pattern Maintenance',
    value: 'ServicePatternDetail',
  },
];
